<template>
  <div class="checkbox-container" style="position:relative;">
    <label class="el-checkbox">
      <span class="el-checkbox__input" :class="{'is-checked':visible}">
        <span class="el-checkbox__inner"></span>
        <input
          @change="changeCheckBox"
          type="checkbox"
          aria-hidden="false"
          class="el-checkbox__original"
          value
        />
      </span>
      <span class="el-checkbox__label">
        <a class="policy" v-maidian="'privacy'" href="https://uat-campaigns.digitalvolvo.com/xc90/privacy.html"></a>
        我已阅读并同意《沃尔沃汽车隐私政策》
      </span>
    </label>
  </div>
</template>
<script>
import { goUrl } from "@/utils/hybird"
export default {
  props: ["value"],
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    goUrl(url,linkId){
      goUrl(url,linkId)
    },
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    }
  }
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
    @{name}: unit(@px / 37.5, rem);
}
.checkbox-container{
  width:100%;
  margin-top:15px;
  margin-left:auto;
  margin-right:auto;
  user-select: none;
  position: relative;
  *{
    user-select: none;
  }
}
.tipBox {
  height: 15px;
  position: relative;
  z-index:20;
  left:20px;
  width:100px;
}
.el-checkbox {
  color:#1c3855;
  font-weight: bold;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  display: flex;
  width: 100%;
  user-select: none;
  align-items: center;
  text-align: left;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
  top:3px;
  vertical-align: middle;
  left:0;
  position: absolute;
}
.el-checkbox__input.is-checked .el-checkbox__inner:before {
  content: "";
  display: block;
  width:100%;
  height:100%;
  left:0;
  top:3px;
  background:url(https://source.qunarzz.com/site/images/wns/20220429-shijianchen-checkbox-selected.png) no-repeat;
  background-size:100% 100%;
}
.el-checkbox__inner {
  display: block;
  position: relative;
  border-radius: 2px;
  width:12px;
  height:12px;
  z-index: 1;
  top:0;
  box-sizing: border-box;
  left:0;
  background:url(https://source.qunarzz.com/site/images/wns/20220429-shijianchen-checkbox.png) no-repeat;
  background-size:100% 100%;
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox__label {
  line-height: 19px;
  float: left;
  padding-left:20px;
  color:#fff;
  img{
    width:100%;
    display: block;
  }
  font-size: 10px;
}
.policy{
  position: absolute;
  width:130px;
  height:20px;
  left: 108px;
  top: 0px;
}
</style>
